<template>
  <div class="notice-preview">
    <div class="system-avatar" aria-label="系统消息">
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <path
          d="M8 26V13a9 9 0 0 1 18 0v13H8Z"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
        <path
          d="M12 13h10M12 17h10M12 21h6"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <article v-if="notice.format === 'card'" class="message-card">
      <h3>{{ notice.title || "通知标题" }}</h3>
      <div class="card-content">
        <p>{{ notice.content || "在左侧填写通知正文" }}</p>
        <img v-if="imageUrl" :src="imageUrl" alt="通知配图" />
        <div v-else class="image-placeholder">
          <i class="el-icon-picture-outline" />
        </div>
      </div>
      <div class="message-link">
        <span>查看详情</span><span class="chevron">›</span>
      </div>
    </article>
    <div v-else class="text-bubble">
      {{ notice.content || "在左侧填写通知正文" }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notice: { type: Object, required: true },
    imageUrl: { type: String, default: "" }
  }
};
</script>

<style scoped>
.notice-preview {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
  color: #192a40;
  width: 100%;
  box-sizing: border-box;
}
.system-avatar {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #4389ee;
  border-radius: 9px;
  color: white;
}
.system-avatar svg {
  width: 28px;
  height: 28px;
}
.message-card {
  background: #fff;
  min-width: 0;
  flex: 1;
  border-radius: 4px;
  box-shadow: 0 1px 4px #203a5910;
  overflow: hidden;
}
.message-card h3 {
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  padding: 15px 16px 9px;
  overflow-wrap: anywhere;
  color: #171d26;
  font-weight: 600;
}
.card-content {
  display: flex;
  gap: 12px;
  padding: 0 16px 15px;
  align-items: flex-start;
  min-height: 76px;
}
.card-content p {
  font-size: 14px;
  line-height: 1.65;
  color: #717883;
  margin: 0;
  flex: 1;
  min-width: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-content img,
.image-placeholder {
  width: 76px;
  height: 76px;
  object-fit: cover;
  flex: 0 0 76px;
  border-radius: 2px;
}
.image-placeholder {
  background: #f1f4f8;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a3afbd;
  font-size: 24px;
}
.message-link {
  margin: 0 16px;
  border-top: 1px solid #edf0f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 0;
  font-size: 13px;
  color: #444b54;
}
.chevron {
  color: #b3bac3;
  font-size: 23px;
  line-height: 14px;
}
.text-bubble {
  background: #fff;
  padding: 13px 16px;
  border-radius: 4px;
  line-height: 1.7;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  min-width: 0;
  flex: 1;
  font-size: 14px;
}
</style>
